'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'steering-wheel';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f622';
var svgPathData = 'M213.2 415l4.9 29.2c-77.6-15.6-138.2-77.8-151.4-156.2 72.8 1.6 134.5 54.8 146.5 127zM256 64c71.1 0 133.1 38.6 166.3 96L89.7 160c33.2-57.4 95.2-96 166.3-96zm42.8 351c12-72.2 73.7-125.4 146.5-127-13.2 78.4-73.8 140.7-151.4 156.2l4.9-29.2zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSteeringWheel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;